<template>
  <Dialog 
    v-model:visible="visible" 
    modal 
    header="Mettre à jour le numéro de téléphone"
    :style="{ width: '450px' }"
    :closable="true"
    @hide="onHide"
  >
    <div class="p-4">
      <div class="mb-4">
        <label class="block mb-2 font-medium">Utilisateur</label>
        <div class="p-3 bg-gray-50 rounded border">
          {{ user?.name || 'Utilisateur' }}
        </div>
      </div>
      
      <div class="mb-6">
        <label class="block mb-2 font-medium">Numéro de téléphone</label>
        <PhoneInput v-model="phoneNumber" placeholder="Entrez le numéro de téléphone" />
      </div>
      
      <div class="flex justify-end gap-2">
        <Button 
          label="Annuler" 
          severity="secondary" 
          outlined 
          @click="onCancel"
          :disabled="isLoading"
        />
        <Button 
          label="Enregistrer" 
          @click="onSave"
          :loading="isLoading"
          :disabled="!phoneNumber.trim()"
        />
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import PhoneInput from './PhoneInput.vue';
import { updateUserPhone } from '@/services/userService';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  user: {
    type: Object,
    default: null
  }
});

const emit = defineEmits(['update:modelValue', 'phone-updated']);

const visible = ref(false);
const phoneNumber = ref('');
const isLoading = ref(false);

watch(() => props.modelValue, (newValue) => {
  visible.value = newValue;
  if (newValue && props.user) {
    phoneNumber.value = props.user.phone || '';
  }
});

watch(visible, (newValue) => {
  emit('update:modelValue', newValue);
});

const onHide = () => {
  visible.value = false;
};

const onCancel = () => {
  visible.value = false;
  phoneNumber.value = '';
};

const onSave = async () => {
  if (!props.user || !phoneNumber.value.trim()) return;
  
  try {
    isLoading.value = true;
    console.log(props.user)
    // Call the API to update user phone
    await updateUserPhone(props.user.id, {
      phone: phoneNumber.value,
      firstname: props.user.firstname,
      lastname: props.user.lastname,
    });
    
    // Emit success event
    emit('phone-updated', {
      userId: props.user.id,
      phone: phoneNumber.value
    });
    
    // Close dialog
    visible.value = false;
    phoneNumber.value = '';
    
  } catch (error) {
    console.error('Error updating phone number:', error);
    // You might want to show an error toast here
  } finally {
    isLoading.value = false;
  }
};
</script>